import { PatchShapeData } from "../Data/PatchShapeData";

export class PatchTemplateData {
    public readonly shape: PatchShapeData;
    public readonly isRotatable: boolean;

    constructor(pShape: PatchShapeData, pIsRotatable: boolean) {
        this.shape = pShape;
        this.isRotatable = pIsRotatable;
    }
}
